export enum DateKind {
   For_Today = "For Today",
   Next_14_Days = "Next 14 Days",
   Custom_Date = "Custom Date",
}
